<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record
        title="Costo hora"
        resource="directo_horas"
        primaryKey="iddirecto_hora"
        :record="record"
        :columns="columns"
        @saveChanges="handleSave"
        :service="service"
        :backLink="
          (record) => {
            return '/personal/' + record.idpersonal;
          }
        "
      />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import Directo_horaService from "@/services/directo_hora.service";
import { directo_hora } from "@/models/directo_hora";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: directo_hora,
      service: Directo_horaService,
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        Directo_horaService.get(this.$route.params.id)
          .then((data) => {
            this.record = data.record;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    },
  },
};
</script>
